module.exports = __webpack_public_path__ + "img/trial-to-basic-custom-poll-mobile.ba74a568.svg";